import React, { useCallback } from "react";

import { Button, Card, Col, Modal, Row } from "react-bootstrap";

import { Link } from "react-router-dom";

import { ResaleInput } from "@generated/graphql";

import { useNextResaleIndex } from "@states/resale_submission";

import { PlusIcon, RightArrowIcon } from "../assets/icons";
import { ROUTES } from "../routes";
import { prefix0ToSingleDigitNumber } from "../util";

import { IconButton } from "./IconButton";

interface ResaleModalProps {
  isOpen: boolean;
  formData: ResaleInput;
  closeModal: () => void;
}

export const ResaleModal = ({ isOpen, closeModal, formData }: ResaleModalProps) => {
  const lastArtist = formData.artist;
  const artistBatchDiscriminator = formData.batch_discriminator;
  const artistName = lastArtist?.provisional_artist_name;
  const artworkPagePathWithArtistPrefill = ROUTES.ResaleSubmission.ArtworkDetails.buildPath(
    {},
    { artistBatchDiscriminator },
  );

  const nextResaleIndex = useNextResaleIndex(formData);

  const handleCloseModal = useCallback(() => closeModal(), [closeModal]);

  return (
    <Modal show={isOpen} centered size="lg">
      <Modal.Body className="p-5">
        <Row className="mt-4 mb-4">
          <Col xs={12} className="text-center">
            <h4>Report {prefix0ToSingleDigitNumber(nextResaleIndex)} added!</h4>
          </Col>
        </Row>
        <Row className="mb-5">
          <Col xs={12} sm={6} className="d-flex align-items-stretch mb-3 ml-2 mr-2">
            <Card bg="info" className="w-100">
              <Card.Body className="d-flex flex-column gap-5">
                <Link to={artworkPagePathWithArtistPrefill}>
                  <IconButton variant="quaternary" src={PlusIcon} onClick={closeModal}></IconButton>
                </Link>
                <Card.Text className="b2 medium">Report another resale of {artistName}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} sm={6} className="d-flex align-items-stretch mb-3 ml-2 mr-2">
            <Card bg="info" className="w-100">
              <Card.Body className="d-flex flex-column gap-5">
                <Link to={ROUTES.ResaleSubmission.ArtistDetails.path}>
                  <IconButton variant="quaternary" src={RightArrowIcon} onClick={closeModal}></IconButton>
                </Link>
                <Card.Text className="b2 medium">Report another resale for next artist</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="text-center mb-4">
          <Col>
            <Link to={ROUTES.SubmitAllResales.path}>
              <Button onClick={handleCloseModal}>Finish creating reports</Button>
            </Link>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};
